var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError501(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 292,
    viewBox: "0 0 301 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3684_654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.233 267.424C205.623 267.424 250.525 222.522 250.525 167.132C250.525 111.743 205.623 66.8406 150.233 66.8406C94.8433 66.8406 49.9412 111.743 49.9412 167.132C49.9412 222.522 94.8433 267.424 150.233 267.424Z",
    fill: "#F9F8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.202 271.331C276.414 271.331 282.261 265.484 282.261 258.272C282.261 251.06 276.414 245.214 269.202 245.214C261.99 245.214 256.143 251.06 256.143 258.272C256.143 265.484 261.99 271.331 269.202 271.331Z",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8138 228.686C61.5194 231.923 54.3755 233.751 46.8068 233.751C21.4105 233.751 0.821777 213.162 0.821777 187.766C0.821777 163.959 18.9197 144.375 42.1021 142.019",
    stroke: "#EE4B99",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.446 162.067C187.446 162.067 223.545 125.221 268.996 137.694C314.672 150.225 306.421 211.798 268.52 209.854C227.445 207.75 238.992 167.158 252.423 183.827C264.755 199.126 263.641 240.464 232.44 247.743",
    stroke: "#EE4B99",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3131 238.443C32.652 238.443 39.4119 231.683 39.4119 223.344C39.4119 215.005 32.652 208.245 24.3131 208.245C15.9743 208.245 9.21436 215.005 9.21436 223.344C9.21436 231.683 15.9743 238.443 24.3131 238.443Z",
    fill: "#FFF7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.963 84.6489C101.963 84.6489 101.371 93.2345 103.418 94.9014C105.464 96.5684 108.747 96.356 109.982 98.8274C111.218 101.299 113.374 103.294 116.766 101.144C120.158 98.9947 117.036 86.348 117.036 86.348L101.97 84.6554L101.963 84.6489Z",
    fill: "black",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.487 126.779L111.128 84.5524L128.762 103.835L132.309 123.554",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.487 126.779L111.128 84.5524L128.762 103.835L132.309 123.554",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.478 46.3356C142.478 46.3356 155.549 69.3442 148.785 93.7687C142.021 118.193 122.14 110.927 112.447 88.5234C112.447 88.5234 109.57 97.3986 99.614 88.015C96.9495 85.5049 94.7162 81.8943 95.038 78.0971C95.3663 74.1647 98.3783 69.5501 102.864 70.7859C107.08 71.9508 108.568 35.4071 135.064 39.6655",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.478 46.3356C142.478 46.3356 155.549 69.3442 148.785 93.7687C142.021 118.193 122.14 110.927 112.447 88.5234C112.447 88.5234 109.57 97.3986 99.614 88.015C96.9495 85.5049 94.7162 81.8943 95.038 78.0971C95.3663 74.1647 98.3783 69.5501 102.864 70.7859C107.08 71.9508 108.568 35.4071 135.064 39.6655",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.333 52.0958C114.333 52.0958 120.454 53.9558 123.845 48.305C127.237 42.6478 134.156 45.1771 138.011 45.3123C141.866 45.4475 147.42 44.1152 149.667 38.5288C151.913 32.9424 155.176 30.6125 158.033 30.7477C160.891 30.8829 161.29 30.2843 159.031 28.553C156.772 26.8218 149.782 27.5555 147.987 29.5506C146.191 31.5458 141.004 32.2087 138.275 29.2159C135.546 26.2232 129.625 27.3559 128.029 28.4179C126.433 29.4798 120.576 26.4871 116.721 28.154C112.866 29.8145 109.738 36.5336 106.674 36.6688C103.617 36.8039 96.2994 41.7918 100.689 49.1095C105.078 56.4272 100.888 49.6437 100.888 49.6437C100.888 49.6437 94.3043 48.91 93.4354 54.7024C92.573 60.4883 97.0911 60.1601 94.8964 65.0772C92.7017 69.9943 91.7428 74.094 95.2697 76.0891L97.2512 72.3744C102.184 68.0931 107.048 72.9741 109.139 74.7376C111.746 79.3457 111.424 79.7705 111.862 79.5645C113.921 78.5992 113.837 78.6378 114.314 78.0778C115.298 76.9258 109.403 72.7553 110.066 67.9991C110.729 63.2107 120.711 62.2132 114.32 52.1023L114.333 52.0958Z",
    fill: "black",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.195 61.4923C131.549 62.374 131.787 63.3652 131.8 64.3177C131.807 64.9677 131.691 65.6757 131.247 66.1777C130.848 66.6282 130.256 66.8084 129.676 66.8535C129.039 66.905 128.383 66.8728 127.752 66.7891C126.999 66.6861 126.252 66.4802 125.583 66.1133C125.512 66.0747 125.435 66.0297 125.371 65.9846",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 72.3048C131.658 72.3048 134.819 69.1438 134.819 65.2445C134.819 61.3453 131.658 58.1843 127.759 58.1843C123.859 58.1843 120.698 61.3453 120.698 65.2445C120.698 69.1438 123.859 72.3048 127.759 72.3048Z",
    fill: "#D9D5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 60.8533C127.995 59.5385 129.947 57.6177 129.467 56.563C128.988 55.5083 126.256 55.7192 123.367 57.034C120.478 58.3488 118.525 60.2696 119.005 61.3243C119.485 62.379 122.216 62.1681 125.105 60.8533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.463 63.2236C124.463 63.2236 127.771 65.8817 131.035 66.8793",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.513 61.1963C130.513 61.1963 130.043 64.8326 124.965 68.4625",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.106 59.0531L146.648 80.5171L140.09 84.649",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.106 59.0531L146.648 80.5171L140.09 84.649",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.186 58.1843C140.572 58.6541 140.978 59.111 141.441 59.5165C142.072 60.07 143.456 61.1126 144.222 60.1859C144.563 59.7804 144.756 59.2012 144.897 58.6927C145.045 58.1521 145.103 57.5922 145.052 57.0322",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.186 58.1843C140.572 58.6541 140.978 59.111 141.441 59.5165C142.072 60.07 143.456 61.1126 144.222 60.1859C144.563 59.7804 144.756 59.2012 144.897 58.6927C145.045 58.1521 145.103 57.5922 145.052 57.0322",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.662 233.172L190.928 245.465L192.35 257.526C179.407 263.627 164.945 267.032 149.686 267.032C122.899 267.032 98.5713 256.535 80.5828 239.421L85.2167 131.831L110.208 128.742L137.348 173.523L144.106 124.404L158.818 122.692L215.384 228.461L212.655 233.172H212.662Z",
    fill: "#D9D5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.95 255.054C79.3406 242.8 61.9699 221.993 54.1116 196.924",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.189 125.073L117.352 127.802L128.917 137.643L130.153 126.309C130.166 126.193 130.314 126.155 130.384 126.245L137.818 136.388L139.182 125.073H139.189Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.236 126.193L138.912 162.067",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.343 155.831L142.864 167.428L143.52 181.304",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.343 155.831L142.864 167.428L143.52 181.304",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.673 123.76L158.825 122.698L202.132 203.682",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.728 136.021L169.773 165.967",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.812 185.005L187.484 233.333",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.155 172.236L177.521 171.071L190.187 171.683L190.271 180.835C190.271 180.835 189.64 185.327 185.058 185.423C180.476 185.52 185.219 177.533 185.219 177.533C185.219 177.533 183.558 186.595 175.32 181.008C175.32 181.008 171.427 185.958 165.48 184.728",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.155 172.236L177.521 171.071L190.187 171.683L190.271 180.835C190.271 180.835 189.64 185.327 185.058 185.423C180.476 185.52 185.219 177.533 185.219 177.533C185.219 177.533 183.558 186.595 175.32 181.008C175.32 181.008 171.427 185.958 165.48 184.728",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61 178.041L186.32 186.839C186.32 186.839 192.131 189.008 193.721 182.72L194.229 175.769L183.436 174.141",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61 178.041L186.32 186.839C186.32 186.839 192.131 189.008 193.721 182.72L194.229 175.769L183.436 174.141",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.785 177.52L197.37 179.586L196.759 184.439C195.465 185.005 190.876 185.05 190.876 185.05L175.816 179.386L176.408 177.571",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.785 177.52L197.37 179.586L196.759 184.439C195.465 185.005 190.876 185.05 190.876 185.05L175.816 179.386L176.408 177.571",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.096 180.538L198.477 184.355L195.819 191.84L193.862 188.313L192.762 186.035C192.762 186.035 187.928 190.102 181.801 185.655C177.914 187.882 170.249 189.549 165.84 186.492C162.043 183.859 158.465 182.102 157.293 179.193C157.119 178.762 156.45 177.095 156.933 175.647C157.448 174.096 163.723 172.23 165.75 172.616",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.096 180.538L198.477 184.355L195.819 191.84L193.862 188.313L192.762 186.035C192.762 186.035 187.928 190.102 181.801 185.655C177.914 187.882 170.249 189.549 165.84 186.492C162.043 183.859 158.465 182.102 157.293 179.193C157.119 178.762 156.45 177.095 156.933 175.647C157.448 174.096 163.723 172.23 165.75 172.616",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.188 191.357L164.16 169.572C164.16 169.572 171.42 171.625 171.085 178.35C170.751 185.076 168.311 196.892 147.832 214.463C127.353 232.033 109.596 219.199 105.593 212.821C99.8456 206.076 83.9552 175.86 85.2231 131.831",
    fill: "#D9D5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.188 191.357L164.16 169.572C164.16 169.572 171.42 171.625 171.085 178.35C170.751 185.076 168.311 196.892 147.832 214.463C127.353 232.033 109.596 219.199 105.593 212.821C99.8456 206.076 83.9552 175.86 85.2231 131.831",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.888 195.908C161.451 201.179 156.122 207.344 147.826 214.463C127.347 232.033 109.596 219.199 105.587 212.828C103.656 210.562 100.605 205.607 97.4321 198.36L103.128 157.53L107.08 129.192L113.419 128.285L150.716 177.288L164.888 195.914V195.908Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.829 118.863L109.339 126.412C109.339 126.412 115.363 127.242 115.614 124.584C115.865 121.926 114.822 118.863 114.822 118.863H114.829Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.494 127.718C114.494 130.087 112.576 132.005 110.208 132.005C107.839 132.005 105.921 130.087 105.921 127.718C105.921 125.35 107.839 123.432 110.208 123.432C111.025 123.432 111.791 123.664 112.441 124.056C113.67 124.809 114.494 126.167 114.494 127.712V127.718Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.845 125.003C107.807 124.938 104.422 119.551 104.383 119.48C103.006 122.261 102.607 124.912 103.739 125.987C104.261 126.483 105.149 126.669 106.796 127.023",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.845 125.003C107.807 124.938 104.422 119.551 104.383 119.48C103.006 122.261 102.607 124.912 103.739 125.987C104.261 126.483 105.149 126.669 106.796 127.023",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3848 31.7067C94.9607 29.5892 114.52 16.4727 132.836 8.38913",
    stroke: "#EE4B99",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1875 24.4147C93.6928 24.9425 64.8467 28.8684 67.183 34.4419C68.039 36.4886 70.9094 36.5851 72.7759 36.5079C75.7042 36.392 78.5361 35.5811 81.3614 34.8732",
    stroke: "#EE4B99",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.994 3.82603C148.308 2.8542 151.732 2.06901 155.201 1.92098C157.57 1.81801 162.989 1.77295 164.115 4.52755C164.437 5.31274 164.173 6.22021 163.755 6.96035C161.167 11.5041 154.242 13.7246 149.647 15.3786C144.646 17.1807 139.452 18.3778 134.246 19.414C126.471 20.965 118.568 21.673 110.716 22.7285",
    stroke: "#EE4B99",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.279 10.1526C141.749 10.1526 143.752 8.14994 143.752 5.67957C143.752 3.2092 141.749 1.20657 139.279 1.20657C136.808 1.20657 134.806 3.2092 134.806 5.67957C134.806 8.14994 136.808 10.1526 139.279 10.1526Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.783 36.4821C87.4643 36.4821 88.8272 35.1192 88.8272 33.4379C88.8272 31.7567 87.4643 30.3937 85.783 30.3937C84.1017 30.3937 82.7388 31.7567 82.7388 33.4379C82.7388 35.1192 84.1017 36.4821 85.783 36.4821Z",
    fill: "white",
    stroke: "#010101",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67 92.5717C129.67 92.5717 133.499 89.4116 140.733 88.9868L129.67 92.5717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67 92.5717C129.67 92.5717 133.499 89.4116 140.733 88.9868",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.643 291.115C227.494 291.115 241.965 276.644 241.965 258.794C241.965 240.943 227.494 226.472 209.643 226.472C191.793 226.472 177.322 240.943 177.322 258.794C177.322 276.644 191.793 291.115 209.643 291.115Z",
    fill: "#FFF7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.352 126.888L155.015 140.372L147.066 143.68L156.534 148.146L143.224 163.779",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.963 230.089C142.858 230.089 143.585 229.363 143.585 228.467C143.585 227.571 142.858 226.845 141.963 226.845C141.067 226.845 140.341 227.571 140.341 228.467C140.341 229.363 141.067 230.089 141.963 230.089Z",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.102 255.781C143.998 255.781 144.724 255.055 144.724 254.16C144.724 253.264 143.998 252.538 143.102 252.538C142.206 252.538 141.48 253.264 141.48 254.16C141.48 255.055 142.206 255.781 143.102 255.781Z",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.393 219.013L148.476 279.981",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3684_654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 290.23,
    fill: "white",
    transform: "translate(0.5 0.884766)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError501);
export default __webpack_public_path__ + "static/media/error501.efb93468df867ea2bccc723fa8af96ed.svg";
export { ForwardRef as ReactComponent };